export default {
  action: (state) => state.action,
  filters: (state) => state.filters,
  query: (state) => state.query,
  view: (state) => state.view,
}
